(function () {
  if (window.__vpPromoTooltipInit) return;
  window.__vpPromoTooltipInit = true;

  function openTooltip(badge) {
    if (!badge || badge.classList.contains('is-tooltip-dismissed')) return;
    badge.classList.add('is-tooltip-open');
  }

  function closeTooltip(badge) {
    if (!badge) return;
    badge.classList.remove('is-tooltip-open');
    badge.classList.remove('is-tooltip-dismissed');
  }

  document.addEventListener(
    'mouseover',
    function (event) {
      var badge = event.target.closest('.vp-promo-badge');
      if (!badge) return;
      openTooltip(badge);
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      var badge = event.target.closest('.vp-promo-badge');
      if (!badge) return;
      var related = event.relatedTarget;
      if (related && badge.contains(related)) return;
      closeTooltip(badge);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('.vp-promo-tooltip__close');
    if (closeBtn) {
      event.preventDefault();
      event.stopPropagation();
      var badge = closeBtn.closest('.vp-promo-badge');
      if (badge) {
        badge.classList.add('is-tooltip-dismissed');
        badge.classList.remove('is-tooltip-open');
      }
      return;
    }

  });

  document.addEventListener('focusin', function (event) {
    var badge = event.target.closest('.vp-promo-badge');
    if (badge) openTooltip(badge);
  });

  document.addEventListener('focusout', function (event) {
    var badge = event.target.closest('.vp-promo-badge');
    if (!badge) return;
    var related = event.relatedTarget;
    if (related && badge.contains(related)) return;
    closeTooltip(badge);
  });
})();
